module.exports = __webpack_public_path__ + "img/noimage-upload.973cc422.png";